import { AfterViewInit, Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { AumicoAppLayoutService } from '@modeso/aumico-layout/services/aumico-app-layout.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import Debug from 'debug';
const debug = Debug('aumico:aumico-layout:NestedAumicoAppPage');
@UntilDestroy()
@Component({
    selector: 'app-aumico-nested-page',
    template: `<ng-template #footerTemplate></ng-template>`,
})
export abstract class NestedAumicoAppPage implements AfterViewInit, OnDestroy {
    @ViewChild('footerTemplate')
    protected footerTemplate: TemplateRef<any>;

    @ViewChild('contentTemplate')
    protected contentTemplate: TemplateRef<any>;
    constructor(protected service: AumicoAppLayoutService) {}

    ngAfterViewInit(): void {
        debug('send footer', this.footerTemplate);
        this.service.changeFooter(this.footerTemplate);
    }
    ngOnDestroy(): void {
        debug('reset footer', undefined);
        this.service.changeFooter(null);
    }
}
